module.exports = __webpack_public_path__ + "img/icon_web04_culture1@2x.7de4af13.png";